import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { APP_CONFIG } from './app/appconfig/appconfig';
import { CLIENT_CONFIG } from './app/appconfig/client-config';

Promise.all([
  fetch('api/ClientEnvironment').then(response => response.json()),
  fetch('api/clientconfig').then(response => response.json())
])
  .then(([environmentConfig, clientConfig]) => {
    // Bootstrap the Angular application with the combined configuration
    platformBrowserDynamic([{ provide: APP_CONFIG, useValue: environmentConfig }, { provide: CLIENT_CONFIG, useValue: clientConfig }])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch(error => console.error('Fetch error:', error));
